import React, { useState } from 'react';
import { Row, Col, Tag, Table, Button } from "antd";

import { FormatNumber } from '../../ValueObjects';

export default function TabDetalheItens({ itensNF }) {

    const [percentualDesc, setPercentualDesc] = useState(true);

    function retornarPercentual(perc_desconto, nfi_valordesconto) {
        if (percentualDesc) {
            return (
                <div>
                    <b>{perc_desconto}</b>%
                </div>
            )
        } else {
            return (
                <div>
                    <b>{FormatNumber(nfi_valordesconto, true)}</b>
                </div>
            )
        }
    };

    return (
        <div className="tabela">
            <Table dataSource={itensNF} columns={
                [
                    {
                        title: '',
                        render: ({ pro_codigo, pro_descricao, atributos }) => (
                            <div>
                                <Row align="middle" gutter={[5, 5]}>
                                    <Col>
                                        <Tag color="processing" className="w-75">
                                            <b>{pro_codigo}</b>
                                        </Tag>
                                    </Col>
                                    <Col>
                                        <b>{(!!pro_descricao ? pro_descricao : 'Débito/Crédito de imposto')}</b>
                                    </Col>
                                    {!!atributos &&
                                        <Col>
                                            <Tag color="default">
                                                <b>{atributos.mgp_descricao}</b>
                                            </Tag>
                                        </Col>
                                    }
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'N°',
                        width: 40,
                        align: 'center',
                        render: ({ nfi_numeroitem }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{(nfi_numeroitem)}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: `${!!itensNF && !!itensNF[0].nis_csosn ? 'CSOSN' : 'CST'}`,
                        width: 40,
                        align: 'center',
                        render: ({ nis_origemmercadoria, nis_csosn, nig_cst, nig_origemmercadoria }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{(!!nis_csosn ? nis_origemmercadoria + nis_csosn : nig_origemmercadoria + nig_cst)}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'CFOP',
                        width: 40,
                        align: 'center',
                        render: ({ nfi_cfop }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{nfi_cfop}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    }, {
                        title: 'NCM',
                        width: 40,
                        align: 'center',
                        render: ({ nfi_ncm }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{nfi_ncm}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'CEST',
                        width: 40,
                        align: 'center',
                        render: ({ cet_id }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{cet_id}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'C.Benef',
                        width: 40,
                        align: 'center',
                        render: ({ cbf_codigo }) => (
                            <div>
                                <Row align="middle" justify="center">
                                    <Col>
                                        <b>{cbf_codigo}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'UM.',
                        width: 20,
                        align: 'center',
                        render: ({ nfi_unidademedida }) => (
                            <div>
                                <Row align="middle" justify="end">
                                    <Col>
                                        <b>{nfi_unidademedida}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'Qtde.',
                        width: 50,
                        align: 'right',
                        render: ({ nfi_qtde }) => (
                            <div>
                                <Row align="middle" justify="end">
                                    <Col>
                                        <b>{nfi_qtde}</b>
                                    </Col>
                                </Row>
                            </div>
                        ),
                    },
                    {
                        title: 'Vlr Unt.(R$)',
                        align: 'right',
                        width: 80,
                        render: ({ nfi_valorunitario }) => (
                            <div>
                                <b>{FormatNumber(nfi_valorunitario, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Frete.(R$)',
                        align: 'right',
                        width: 40,
                        render: ({ nfi_valorfrete }) => (
                            <div>
                                <b>{FormatNumber(nfi_valorfrete, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: 'Acrés.(R$)',
                        align: 'right',
                        width: 40,
                        render: ({ nfi_valoroutros }) => (
                            <div>
                                <b>{FormatNumber(nfi_valoroutros, true)}</b>
                            </div>
                        ),
                    },
                    {
                        title: () => {
                            return (
                                <div>
                                    <Row align="middle" justify="end" gutter={[4, 0]}>
                                        <Col>
                                            Desc.
                                        </Col>
                                        <Col>
                                            <Button size="small" onClick={() => { setPercentualDesc(!percentualDesc) }}>{(percentualDesc ? '%' : 'R$')}</Button>
                                        </Col>
                                    </Row>
                                </div>
                            )
                        },
                        width: 70,
                        align: 'right',
                        render: ({ perc_desconto, nfi_valordesconto }) => (
                            retornarPercentual(perc_desconto, nfi_valordesconto)
                        ),
                    },
                    {
                        title: 'Vlr Total (R$)',
                        align: 'right',
                        width: 100,
                        render: ({ nfi_valorunitario, nfi_qtde }) => (
                            <div>
                                <b>{FormatNumber(nfi_qtde * nfi_valorunitario, true)}</b>
                            </div>
                        ),
                    }
                ]
            } />
        </div>
    );
}